import { Node } from 'slate';

import { DEFINITIONS as PLUGIN_DEFINITIONS } from '@xing-com/content-editor-plugin-summary';

import {
  DESERIALIZATION,
  SERIALIZATION,
  SUMMARY_FIELDENAME,
  SUMMARY_TYPENAME,
} from '../constants';

const DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: SUMMARY_TYPENAME,
};

const summarySerializer = ({ createBlock, matchBlock, node, direction }) => {
  if (matchBlock({ node, match: DEFINITIONS })) {
    if (direction === SERIALIZATION) {
      return { [SUMMARY_FIELDENAME]: { text: Node.string(node) } };
    }
    if (direction === DESERIALIZATION) {
      return createBlock({
        node,
        definitions: DEFINITIONS,
        children: [{ text: node.text }],
      });
    }
  }
};

export { summarySerializer };
